import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

type BotMode = 'idle' | 'tracking';

@Component({
  selector: 'app-zaxbot',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="zaxbot" [class.zaxbot--success]="success">
      <div class="zaxbot__antenna-base"></div>
      <div class="zaxbot__antenna">
        <div class="zaxbot__antenna-dot"></div>
      </div>
      <div class="zaxbot__head">
        <div class="zaxbot__visor-frame">
          <div class="zaxbot__visor">
            <div class="zaxbot__eye">
              <div class="zaxbot__pupil" [style.transform]="'translate(' + eyeX + 'px, ' + eyeY + 'px)'"></div>
            </div>
            <div class="zaxbot__eye">
              <div class="zaxbot__pupil" [style.transform]="'translate(' + eyeX + 'px, ' + eyeY + 'px)'"></div>
            </div>
          </div>
        </div>
        <div class="zaxbot__mouth" [class.zaxbot__mouth--open]="mouthOpen">
          <div class="zaxbot__teeth"></div>
          <div class="zaxbot__teeth"></div>
          <div class="zaxbot__teeth"></div>
          <div class="zaxbot__teeth"></div>
        </div>
      </div>
      <div class="zaxbot__body">
        <div class="zaxbot__arm zaxbot__arm--left" [class.zaxbot__arm--wave]="waving"></div>
        <div class="zaxbot__arm zaxbot__arm--right"></div>
        <div class="zaxbot__chest">
          <div class="zaxbot__led" [class.active]="ledActive[0]"></div>
          <div class="zaxbot__led" [class.active]="ledActive[1]"></div>
          <div class="zaxbot__led" [class.active]="ledActive[2]"></div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .zaxbot { display:flex; flex-direction:column; align-items:center; gap:0; user-select:none; filter: drop-shadow(0 4px 6px rgba(0,0,0,0.5)); }
    
    .zaxbot__antenna-base { width: 16px; height: 6px; background: #9ca3af; border: 2px solid #374151; border-top-left-radius: 8px; border-top-right-radius: 8px; margin-bottom: -2px; z-index: 2; }
    .zaxbot__antenna { width: 6px; height: 18px; background: #9ca3af; border-left: 2px solid #374151; border-right: 2px solid #374151; position: relative; z-index: 1; margin-bottom: -1px; }
    .zaxbot__antenna-dot { position: absolute; top: -8px; left: 50%; transform: translateX(-50%); width: 14px; height: 14px; background: #ef4444; border: 2px solid #7f1d1d; border-radius: 50%; animation: ant-blink 1.2s infinite; }
    @keyframes ant-blink { 0%, 100% { background: #ef4444; box-shadow: 0 0 0 transparent; } 50% { background: #fca5a5; box-shadow: 0 0 8px #ef4444; } }
    
    .zaxbot__head { width: 72px; background: linear-gradient(90deg, #9ca3af 0%, #d1d5db 20%, #e5e7eb 50%, #d1d5db 80%, #9ca3af 100%); border: 2px solid #374151; border-radius: 36px 36px 8px 8px; display: flex; flex-direction: column; align-items: center; padding: 12px 0 8px; gap: 8px; z-index: 3; position: relative; box-shadow: inset -4px 0 10px rgba(0,0,0,0.2); }
    
    .zaxbot__visor-frame { width: 64px; background: #374151; padding: 4px; border-radius: 8px; border: 2px solid #1f2937; box-shadow: inset 0 2px 4px rgba(0,0,0,0.5); }
    .zaxbot__visor { display: flex; gap: 4px; justify-content: center; background: #fef08a; padding: 4px; border-radius: 4px; border: 1px solid #ca8a04; box-shadow: inset 0 0 8px rgba(202,138,4,0.5); }
    .zaxbot__eye { width: 20px; height: 20px; background: #fef08a; display: flex; align-items: center; justify-content: center; overflow: hidden; position: relative; border-radius: 50%; }
    .zaxbot__pupil { position: absolute; width: 10px; height: 10px; background: #111827; border-radius: 50%; transition: transform 0.1s ease-out; }
    .zaxbot__pupil::after { content: ''; position: absolute; top: 2px; right: 2px; width: 3px; height: 3px; background: white; border-radius: 50%; }
    
    .zaxbot__mouth { width: 44px; height: 16px; background: #fef08a; border: 2px solid #374151; border-radius: 8px; display: flex; justify-content: space-evenly; overflow: hidden; transition: all 0.2s; box-shadow: inset 0 2px 4px rgba(0,0,0,0.3); }
    .zaxbot__teeth { width: 2px; height: 100%; background: #374151; opacity: 0.7; }
    .zaxbot__mouth--open { height: 24px; background: #111827; border-radius: 12px; }
    .zaxbot__mouth--open .zaxbot__teeth { display: none; }
    
    .zaxbot__body { width: 88px; height: 48px; background: linear-gradient(90deg, #9ca3af 0%, #d1d5db 20%, #e5e7eb 50%, #d1d5db 80%, #9ca3af 100%); border: 2px solid #374151; border-radius: 16px 16px 4px 4px; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; padding-top: 12px; position: relative; z-index: 2; margin-top: -6px; box-shadow: inset -4px 0 10px rgba(0,0,0,0.2); }
    
    .zaxbot__arm { position: absolute; width: 16px; height: 36px; background: repeating-linear-gradient(0deg, #9ca3af, #9ca3af 4px, #4b5563 4px, #4b5563 6px); border: 2px solid #374151; border-radius: 8px; top: 8px; z-index: 1; }
    .zaxbot__arm--left { left: -14px; transform-origin: top center; transform: rotate(15deg); }
    .zaxbot__arm--right { right: -14px; transform-origin: top center; transform: rotate(-15deg); }
    .zaxbot__arm--wave { animation: wave 0.5s ease-in-out infinite alternate; }
    @keyframes wave { from { transform: rotate(-10deg); } to { transform: rotate(45deg); } }
    
    .zaxbot__chest { display: flex; gap: 6px; background: #374151; padding: 4px 8px; border-radius: 6px; border: 2px solid #1f2937; box-shadow: inset 0 2px 4px rgba(0,0,0,0.5); }
    .zaxbot__led { width: 10px; height: 10px; background: #374151; border-radius: 50%; border: 1px solid #111827; transition: background 0.1s, box-shadow 0.1s; }
    .zaxbot__led.active { background: #22c55e; box-shadow: 0 0 6px #22c55e; }
    
    .zaxbot--success .zaxbot__head { animation: success-bop 0.4s ease-in-out 3; }
    @keyframes success-bop { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
  `]
})
export class ZaxbotComponent implements OnInit, OnDestroy, OnChanges {
  @Input() mode: BotMode = 'idle';
  @Input() digitCount = 0;
  @Input() success = false;

  eyeX = 0;
  eyeY = 0;
  mouthOpen = false;
  waving = false;
  ledActive = [false, false, false];

  private timers: ReturnType<typeof setTimeout>[] = [];
  private ledInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit() {
    this.startLedSequence();
    if (this.mode === 'idle') this.runIdleLoop();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['mode'] && !changes['mode'].firstChange) {
      this.clearTimers();
      if (this.mode === 'idle') this.runIdleLoop();
      else { this.eyeY = 0; }
    }
    if (changes['digitCount'] && this.mode === 'tracking') this.trackDigit(this.digitCount);
    if (changes['success'] && this.success) { this.eyeX = 0; this.eyeY = -3; this.mouthOpen = false; }
  }

  ngOnDestroy() {
    this.clearTimers();
    if (this.ledInterval) clearInterval(this.ledInterval);
  }

  private trackDigit(count: number) {
    this.eyeX = count === 0 ? 0 : Math.round((count / 6) * 10 - 5);
    this.eyeY = count > 0 ? 2 : 0;
    this.mouthOpen = count > 0 && count < 6;
  }

  private runIdleLoop() {
    const schedule = () => {
      const t = setTimeout(() => { this.doIdleTrick(); schedule(); }, 1000 + Math.random() * 2000);
      this.timers.push(t);
    };
    schedule();
  }

  private doIdleTrick() {
    const tricks = [
      () => this.lookRandom(),
      () => this.lookRandom(),
      () => { this.mouthOpen = true; setTimeout(() => this.mouthOpen = false, 500); },
      () => { this.waving = true; setTimeout(() => this.waving = false, 1500); },
      () => { this.eyeY = -4; setTimeout(() => this.eyeY = 0, 800); },
      () => { this.eyeY = 4;  setTimeout(() => this.eyeY = 0, 800); },
    ];
    tricks[Math.floor(Math.random() * tricks.length)]();
  }

  private lookRandom() {
    const dirs: [number,number][] = [[-5,0],[5,0],[0,-4],[0,4],[0,0],[-4,-3],[4,-3]];
    const [x, y] = dirs[Math.floor(Math.random() * dirs.length)];
    this.eyeX = x; this.eyeY = y;
    const t = setTimeout(() => { this.eyeX = 0; this.eyeY = 0; }, 800 + Math.random() * 600);
    this.timers.push(t);
  }

  private startLedSequence() {
    let i = 0;
    this.ledInterval = setInterval(() => {
      this.ledActive = [false, false, false];
      this.ledActive[i % 3] = true;
      i++;
    }, 400);
  }

  private clearTimers() {
    this.timers.forEach(t => clearTimeout(t));
    this.timers = [];
  }
}
